module.exports = __webpack_public_path__ + "img/monkaS.24d2829c.png";